import { useRef } from "react";

export const useSignatureManager = () => {
  const canvasRef = useRef(null);

  const isCanvasDrawn = () => {
    if (!canvasRef.current) return false;
    
    try {
      // For react-signature-canvas, check if there's any drawing
      const canvas = canvasRef.current.getTrimmedCanvas();
      if (!canvas) return false;
      
      const ctx = canvas.getContext("2d");
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      
      // Check if any pixel is not transparent (alpha > 0)
      for (let i = 3; i < data.length; i += 4) {
        if (data[i] > 128) return true;
      }
      return false;
    } catch (error) {
      console.error("Error checking canvas:", error);
      return false;
    }
  };

  const clearCanvas = () => {
    if (canvasRef.current && typeof canvasRef.current.clear === "function") {
      canvasRef.current.clear();
    }
  };

  const exportCanvasAsBase64 = async () => {
    return new Promise((resolve, reject) => {
      try {
        if (canvasRef.current) {
          const trimmedCanvas = canvasRef.current.getTrimmedCanvas();
          const dataUrl = trimmedCanvas.toDataURL("image/png");
          resolve(dataUrl);
        } else {
          reject(new Error("Canvas reference not available"));
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  const validateFileSize = (file, maxSizeMB = 2) => {
    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    return file.size <= maxSizeBytes;
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  return {
    canvasRef,
    isCanvasDrawn,
    clearCanvas,
    exportCanvasAsBase64,
    validateFileSize,
    fileToBase64,
  };
};
